const companyData = {
  name: "PET Stream Incorporation",
  tagline: "Trust and Precision in Manufacturing",
  description: "PET Stream Incorporation is a leading project delivery company, provides Project consultancy, Sales, and service in the fields of beverage, packaging, healthcare, precision technology, and other relevant fields of plastics industries, representing world-class manufacturers of capital equipment and tools.",
  vision: "To become the most trusted partner for manufacturing solutions in the plastics industry across India and South Asia.",
  mission: "To deliver superior technological solutions and services that empower our customers to achieve higher profit margins and operational excellence.",
  history: {
    paragraph1: "PET Stream Incorporation is a leading project delivery company, provides Project consultancy, Sales, and service in the fields of beverage, packaging, healthcare, precision technology, and other relevant fields of plastics industries, representing world-class manufacturers of capital equipment and tools.",
    paragraph2: "Our company Leadership is having active experience of more than two decades in the Indian manufacturing sector, this expertise and exposure have shaped our vision which relies on trust and precision, we value time, we have hands-on experience to guide our customers to select the right equipment for their higher profit margin in the time of need.",
    paragraph3: "Our capabilities are beyond a Sales & Service Partner, we also offer services e.g. – Machine Refurbishment, Hot Runner on-site refurbishment, Annual maintenance contract, Plant Audit, Breakdown service, Project consultation, and New Product development to our customers."
  },
  values: [
    {
      title: "Trust",
      description: "Building lasting relationships with our customers through honesty and reliability."
    },
    {
      title: "Precision",
      description: "Delivering accurate solutions tailored to each client's specific needs."
    },
    {
      title: "Innovation",
      description: "Constantly seeking better technologies and methodologies to improve outcomes."
    },
    {
      title: "Excellence",
      description: "Striving for the highest quality in every project and service we deliver."
    }
  ],
  contact: {
    phone: "+91-9811206119",
    email: "info@petstream.in",
    address: "Office No. 1603A & 1603B, 16th floor, The Iconic Tower, Corenthum, Sector -62, Noida, National Capital Region, India-201309"
  }
};

export default companyData;